import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row } from 'reactstrap';
import {
  enhancedRouting,
  SetSelectedBoxes,
  getEpikBoxData,
} from '../../../../../actions/EpikBoxes';
import { TOOLTIPS_TEXT } from '../../../../../lib/constants';
import AddSecurityCodeModal from '../../../../AddSecurityCodeModal';
import InfoPopup from '../../../../InfoPopup';
import Toggle from '../../../../Toggle';
import Spinner from '../../../../../components/Spinner/Spinner';
import addBoxAction from '../../../../../lib/api/addBoxAction';
import { getPermissionForComponent } from '../../../../../utils/permissionsUtils';

const EnhancedRouting = ({user}) => {
  const dispatch = useDispatch();
  const token = localStorage.getItem('jwtToken');
  const boxDetails = useSelector(state => state.AppState.boxDetails.box);

  const [enableEnhanceRouting, setEnableEnhanceRouting] = useState(
    boxDetails.advancedRouting || false,
  );
  const [modalLoading, setModalLoading] = useState(false);

  // const enhancedRoutingPermission = getPermissionForComponent('enhancedRouting',user.permissionsGroup);

  const checkSecurityCode = async () => {
    setModalLoading(true);
    const advEnhance = await dispatch(
      enhancedRouting(token, boxDetails._id, !enableEnhanceRouting),
    );
    if (advEnhance) {
      await dispatch(getEpikBoxData(token, boxDetails?._id));

      const LOG_MESSAGE = !enableEnhanceRouting ? 'enabled Enhanced Routing' : 'disabled Enhanced Routing'
      addBoxAction({ boxID: boxDetails?._id, activity: LOG_MESSAGE });

      setEnableEnhanceRouting(!enableEnhanceRouting);
    }
    setModalLoading(false);
  };

  const checkThirdOctet = parseInt(boxDetails?.vpnAddress?.split('.')[2], 10) >= 20;

  return (
    <>
      {/* no need of permission for enhanced routing */}
      {/* {enhancedRoutingPermission && (*/}
      <Row className="align-items-center">
        {modalLoading ? <Spinner /> : null}
        <Col sm={5} id="test-enable-expansion-box" className="type-header d-flex">
          Enhanced Routing
          <sup>
            <InfoPopup id="enable-enhanced-routing" text={TOOLTIPS_TEXT.ENABLE_ADVANCED_ROUTING} />
          </sup>
        </Col>
  
        <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
          <Toggle
            value={enableEnhanceRouting}
            id="test-enable-expansion-box-toggle"
            onToggle={() => {
              // if (enhancedRoutingPermission === 'write' || enhancedRoutingPermission === 'both') {
                checkSecurityCode();
              // }
            }}
            // disabled={enhancedRoutingPermission === 'read' || !['la', 'ny', 'at', 'ch'].includes(boxDetails?.datacenter) || !checkThirdOctet}
            disabled={!['la', 'ny', 'at', 'ch'].includes(boxDetails?.datacenter) || !checkThirdOctet}
            customDisableText={'Enhanced Routing is disabled for V2 devices'}
          />
        </Col>
      </Row>
      {/* )} */}
    </>
   
  );
};

export default EnhancedRouting;
